export default {
  name: 'Empty',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {}
};
